import PropTypes from "prop-types"
import React from "react"

import { Row, Col, CardBody, Card, Container, Form } from "reactstrap"

//redux
import { Link, Navigate, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
// import images
import profile from "assets/images/profile-img.png"
import logoIcon from "assets/images/logo-icon.png"

// import library & components
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import LoadingButton from "components/Common/LoadingButton"
import InputRHF from "components/RHF/InputRHF"
import { t } from "i18next"
import { toast } from "react-toastify"
import { useMutation } from "@tanstack/react-query"
import useAuth from "hooks/useAuth"
import { login_schema } from "helpers/validationSchema"
import redirectUser from "helpers/redirectUser"

const Login = () => {
  //meta title
  document.title = "Login | Pixamo"
  const { getUserToken, getUserProfile, userData } = useAuth()
  const navigate = useNavigate()

  const { handleSubmit, control } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
    resolver: yupResolver(login_schema),
  })

  const { mutate, isPending } = useMutation({
    mutationFn: async values => {
      await getUserToken(values)
      const { user_type } = await getUserProfile()
      navigate(redirectUser(user_type))
    },
    onError: error => toast.error(error),
  })

  if (userData) {
    return <Navigate to={redirectUser(userData.user_type)} />
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("welcome back")} !</h5>
                        <p>{t("sign in to continue to pixamo")}.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="profile" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="logo-light-element">
                    <div className="avatar-md profile-user-wid mb-4">
                      <span className="avatar-title rounded-circle bg-light">
                        <img src={logoIcon} alt="logo" height="38" />
                      </span>
                    </div>
                  </div>

                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={handleSubmit(mutate)}
                    >
                      <InputRHF
                        name="username"
                        label={t("username")}
                        placeholder={t("enter username")}
                        control={control}
                      />
                      <InputRHF
                        type="password"
                        name="password"
                        label={t("password")}
                        placeholder={t("enter password")}
                        control={control}
                      />
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          {t("remember me")}
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <LoadingButton
                          isLoading={isPending}
                          color="primary"
                          type="submit"
                        >
                          {t("login")}
                        </LoadingButton>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          {t("forgot your password")}?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
